import { Message, proto3, protoInt64 } from '@bufbuild/protobuf';
/**
 * @generated from message plugnmeet.CreateBreakoutRoomsReq
 */
export class CreateBreakoutRoomsReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: string requested_user_id = 2;
         */
        this.requestedUserId = '';
        /**
         * @generated from field: uint64 duration = 3;
         */
        this.duration = protoInt64.zero;
        /**
         * @generated from field: repeated plugnmeet.BreakoutRoom rooms = 5;
         */
        this.rooms = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CreateBreakoutRoomsReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateBreakoutRoomsReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateBreakoutRoomsReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateBreakoutRoomsReq, a, b);
    }
}
CreateBreakoutRoomsReq.runtime = proto3;
CreateBreakoutRoomsReq.typeName = 'plugnmeet.CreateBreakoutRoomsReq';
CreateBreakoutRoomsReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 2,
        name: 'requested_user_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    { no: 3, name: 'duration', kind: 'scalar', T: 4 /* ScalarType.UINT64 */ },
    {
        no: 4,
        name: 'welcome_msg',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    { no: 5, name: 'rooms', kind: 'message', T: BreakoutRoom, repeated: true },
]);
/**
 * @generated from message plugnmeet.BreakoutRoom
 */
export class BreakoutRoom extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = '';
        /**
         * @generated from field: string title = 2;
         */
        this.title = '';
        /**
         * @generated from field: uint64 duration = 3;
         */
        this.duration = protoInt64.zero;
        /**
         * @generated from field: bool started = 4;
         */
        this.started = false;
        /**
         * @generated from field: uint64 created = 5;
         */
        this.created = protoInt64.zero;
        /**
         * @generated from field: repeated plugnmeet.BreakoutRoomUser users = 6;
         */
        this.users = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BreakoutRoom().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BreakoutRoom().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BreakoutRoom().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BreakoutRoom, a, b);
    }
}
BreakoutRoom.runtime = proto3;
BreakoutRoom.typeName = 'plugnmeet.BreakoutRoom';
BreakoutRoom.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'duration', kind: 'scalar', T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: 'started', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: 'created', kind: 'scalar', T: 4 /* ScalarType.UINT64 */ },
    {
        no: 6,
        name: 'users',
        kind: 'message',
        T: BreakoutRoomUser,
        repeated: true,
    },
]);
/**
 * @generated from message plugnmeet.BreakoutRoomUser
 */
export class BreakoutRoomUser extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = '';
        /**
         * @generated from field: string name = 2;
         */
        this.name = '';
        /**
         * @generated from field: bool joined = 3;
         */
        this.joined = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BreakoutRoomUser().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BreakoutRoomUser().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BreakoutRoomUser().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BreakoutRoomUser, a, b);
    }
}
BreakoutRoomUser.runtime = proto3;
BreakoutRoomUser.typeName = 'plugnmeet.BreakoutRoomUser';
BreakoutRoomUser.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'joined', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message plugnmeet.IncreaseBreakoutRoomDurationReq
 */
export class IncreaseBreakoutRoomDurationReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string breakout_room_id = 1;
         */
        this.breakoutRoomId = '';
        /**
         * @generated from field: uint64 duration = 2;
         */
        this.duration = protoInt64.zero;
        /**
         * @generated from field: string room_id = 3;
         */
        this.roomId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new IncreaseBreakoutRoomDurationReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IncreaseBreakoutRoomDurationReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IncreaseBreakoutRoomDurationReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IncreaseBreakoutRoomDurationReq, a, b);
    }
}
IncreaseBreakoutRoomDurationReq.runtime = proto3;
IncreaseBreakoutRoomDurationReq.typeName = 'plugnmeet.IncreaseBreakoutRoomDurationReq';
IncreaseBreakoutRoomDurationReq.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'breakout_room_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    { no: 2, name: 'duration', kind: 'scalar', T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.BroadcastBreakoutRoomMsgReq
 */
export class BroadcastBreakoutRoomMsgReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string msg = 1;
         */
        this.msg = '';
        /**
         * @generated from field: string room_id = 3;
         */
        this.roomId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BroadcastBreakoutRoomMsgReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BroadcastBreakoutRoomMsgReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BroadcastBreakoutRoomMsgReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BroadcastBreakoutRoomMsgReq, a, b);
    }
}
BroadcastBreakoutRoomMsgReq.runtime = proto3;
BroadcastBreakoutRoomMsgReq.typeName = 'plugnmeet.BroadcastBreakoutRoomMsgReq';
BroadcastBreakoutRoomMsgReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.JoinBreakoutRoomReq
 */
export class JoinBreakoutRoomReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string breakout_room_id = 1;
         */
        this.breakoutRoomId = '';
        /**
         * @generated from field: string user_id = 2;
         */
        this.userId = '';
        /**
         * @generated from field: string room_id = 3;
         */
        this.roomId = '';
        /**
         * @generated from field: bool is_admin = 4;
         */
        this.isAdmin = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new JoinBreakoutRoomReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new JoinBreakoutRoomReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new JoinBreakoutRoomReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(JoinBreakoutRoomReq, a, b);
    }
}
JoinBreakoutRoomReq.runtime = proto3;
JoinBreakoutRoomReq.typeName = 'plugnmeet.JoinBreakoutRoomReq';
JoinBreakoutRoomReq.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'breakout_room_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    { no: 2, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'is_admin', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message plugnmeet.EndBreakoutRoomReq
 */
export class EndBreakoutRoomReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string breakout_room_id = 1;
         */
        this.breakoutRoomId = '';
        /**
         * @generated from field: string room_id = 3;
         */
        this.roomId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EndBreakoutRoomReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EndBreakoutRoomReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EndBreakoutRoomReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EndBreakoutRoomReq, a, b);
    }
}
EndBreakoutRoomReq.runtime = proto3;
EndBreakoutRoomReq.typeName = 'plugnmeet.EndBreakoutRoomReq';
EndBreakoutRoomReq.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'breakout_room_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    { no: 3, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.BreakoutRoomRes
 */
export class BreakoutRoomRes extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool status = 1;
         */
        this.status = false;
        /**
         * @generated from field: string msg = 2;
         */
        this.msg = '';
        /**
         * rooms list
         *
         * @generated from field: repeated plugnmeet.BreakoutRoom rooms = 5;
         */
        this.rooms = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BreakoutRoomRes().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BreakoutRoomRes().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BreakoutRoomRes().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BreakoutRoomRes, a, b);
    }
}
BreakoutRoomRes.runtime = proto3;
BreakoutRoomRes.typeName = 'plugnmeet.BreakoutRoomRes';
BreakoutRoomRes.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'status', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 3,
        name: 'token',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    { no: 4, name: 'room', kind: 'message', T: BreakoutRoom, opt: true },
    { no: 5, name: 'rooms', kind: 'message', T: BreakoutRoom, repeated: true },
]);
